export class ProjectDetailConstant
{
    AUDIT_SUMMARY_SAVE_SUCCESS:string = 'Audit Summary saved successfully!';
    AUDIT_SUMMARY_SAVE_ERROR: string = 'Error while saving audit summary:';
    RISK_REGISTER_SAVED_SUCCESS:string = 'Risk Register data saved successfully!';
    RISK_REGISTER_SAVE_ERROR: string = 'Error while submitting final review:';
    AUDDIT_FINAL_REVIEW_SUBMIT_SUCCESS:string= 'Final review submitted successfully';
    AUDDIT_FINAL_REVIEW_SUBMIT_ERROR: string = 'Error while final review submit:';
    CLASSIFICATION_MAIL_SENT_SUCCESS: string = 'Classification mail sent successfully';
    CLASSIFICATION_MAIL_SENT_ERROR: string = 'Error while sending classificaton mail:';
    SAVE_ASSIGNEE_API_ERROR: string = 'Error while saving category assignee: '

    GET_ASSIGNEES_API_ERROR: string = 'Error in get assignees call/API:';
    GET_STAGES_REVIEW_DETAIL_API_ERROR: string = 'Error in getStageReviewDetails call/API:';
    GET_CATEGORY_DROPDOWN_API_ERROR: string = 'Error in getCategoryDropDown call/API:';
    GET_SUBCATEGORY_DROPDOWN_API_ERROR: string = 'Error in getSubCategoryDropDown call/API:';
    GET_RESPONSE_DROPDOWN_API_ERROR: string = 'Error in getResponseDropDown call/API:';
    GET_FINAL_REVIEW_RATING_API_ERROR: string = 'Error in getFinalReviewRating call/API:';
    GET_PROJECT_STATUS_API_ERROR: string = 'Error while getting getProjectStatus:';
    GET_CATEGORY_REVIEWER_API_ERROR: string = 'Error in getCategoryReviewer call/API: ';
    QEUSTION_RESPONSE_SAVE_SUCCESS:string = 'Response saved successfully!';
    QEUSTION_RESPONSE_SUBMIT_SUCCESS:string = 'Response submitted successfully!';
    QEUSTION_RESPONSE_SAVE_ERROR:string = 'Error occured while saving question(s) response: ';
    QEUSTION_RESPONSE_SUBMIT_ERROR:string = 'Error occured while Submitting question(s) response: ';


    GET_QUESTION_TABLE_DATA_API_ERROR: string = 'Error in getCategoryDropDown call/API: ';
    // GET_RESPONSE_DROPDOWN_API_ERROR: string = 'Error in getQuestions call/API: ';
    // GET_CATEGORY_DROPDOWN_API_ERROR: string = 'Error in getCategoryDropDown call/API: ';
    // GET_CATEGORY_REVIEWER_API_ERROR: string = 'Error in getCategoryReviewer call/API: ';
    GET_QUESTION_RESPONSE_API_ERROR: string = 'Error in getQuestionResponse call/API: ';
    
    CATEGORY_REVIEW_SUBMIT_SUCCESS: string = 'Category review submitted successfully';
    CATEGORY_REVIEW_SUBMIT_ERROR:string = 'Error occured while saving review: ';
}